import { TranslateService } from "ng2-translate";
import { LotteryGame } from "./LotteryGame";

export const mmcFace = (translate: TranslateService): LotteryGame[] => [
    {
        isdefault: true,
        title: translate.instant('DANH_DE'),
        status: 0,
        label: [
            {
                gtitle: translate.instant('SIEU_TOC'),
                label: [

                    {
                        name: translate.instant('DE_DAC_BIET'),
                        methodid: 6,
                        selectType: "zxfs",
                        selectArea: {
                            mname: "dedacbiet",
                            layout: [
                                {
                                    title: translate.instant('CHUC'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('DON_VI'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('METHOD_DESC_DE_DAC_BIET'),
                        methodhelp: translate.instant('METHOD_HELP_DE_DAC_BIET'),
                        guideTxt: translate.instant('GUIDE_TEXT_COMMON'),
                        methodexample: translate.instant('METHOD_EXAMPLE_COMMON'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: translate.instant('VND'),
                            rate: 1
                        }]
                    },
                    {
                        name: translate.instant('DE_DAU'),
                        methodid: 7,
                        selectType: "zxfs",
                        selectArea: {
                            mname: "dedau",
                            layout: [
                                {
                                    title: translate.instant('CHUC'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('DON_VI'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('METHOD_DESC_DE_DAU'),
                        methodhelp: translate.instant('METHOD_HELP_DE_DAU'),
                        guideTxt: translate.instant('GUIDE_TEXT_COMMON'),
                        methodexample: translate.instant('METHOD_EXAMPLE_COMMON'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: translate.instant('VND'),
                            rate: 1
                        }]
                    },
                    {
                        name: translate.instant('DE_DAU_DUOI'),
                        methodid: 8,
                        selectType: "zxfs",
                        selectArea: {
                            mname: "dedauduoi",
                            layout: [
                                {
                                    title: translate.instant('CHUC'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('DON_VI'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('METHOD_DESC_DE_DAU_DUOI'),
                        methodhelp: translate.instant('METHOD_HELP_DE_DAU_DUOI'),
                        guideTxt: translate.instant('GUIDE_TEXT_COMMON'),
                        methodexample: translate.instant('METHOD_EXAMPLE_COMMON'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: translate.instant('VND'),
                            rate: 1
                        }]
                    },

// TAIXUI
                    {
                        name: translate.instant('TAI_XIU'),
                        methodid: 200,
                        selectType: "deTopBot",
                        selectArea: {
                            mname: "detx",
                            LayoutTopBot: [
                                {
                                    title: translate.instant('TAI'),
                                    no: [
                                        {
                                            title: translate.instant('TAI_GIAI_8'),
                                            codePlay: "TAI8",
                                            methodid: 200,
                                            rate: 1.95
                                        },
                                        {
                                            title: translate.instant('TAI_GIAI_DB'),
                                            codePlay: "TAIDB",
                                            methodid: 201,
                                            rate: 1.95
                                        },
                                        {
                                            title: translate.instant('TAI_GIAI_8_OR_DB'),
                                            codePlay: "TAI8DB",
                                            methodid: 204,
                                            rate: 1.3
                                        },
                                        {
                                            title: translate.instant('TAI_GIAI_8_AND_DB'),
                                            codePlay: "TAI8VDB",
                                            methodid: 205,
                                            rate: 3.7
                                        },
                                        {
                                            title: translate.instant('TAI_AND_CHAN_GIAI_8'),
                                            codePlay: "TAICHAN8",
                                            methodid: 206,
                                            rate: 3.63
                                        },
                                        {
                                            title: translate.instant('TAI_AND_LE_GIAI_8'),
                                            codePlay: "TAILE8",
                                            methodid: 207,
                                            rate: 3.63
                                        },
                                        {
                                            title: translate.instant('TAI_AND_CHAN_GIAI_DB'),
                                            codePlay: "TAICHANDB",
                                            methodid: 208,
                                            rate: 3.63
                                        },
                                        {
                                            title: translate.instant('TAI_AND_LE_GIAI_DB'),
                                            codePlay: "TAILEDB",
                                            methodid: 209,
                                            rate: 3.63
                                        }
                                    ]
                                },
                                {
                                    title: translate.instant('XIU'),
                                    no: [
                                        {
                                            title: translate.instant('XIU_GIAI_DB'),
                                            codePlay: "XIUDB",
                                            methodid: 202,
                                            rate: 1.95
                                        },
                                        {
                                            title: translate.instant('XIU_GIAI_8'),
                                            codePlay: "XIU8",
                                            methodid: 203,
                                            rate: 1.95
                                        },
                                        {
                                            title: translate.instant('XIU_GIAI_8_OR_DB'),
                                            codePlay: "XIU8DB",
                                            methodid: 210,
                                            rate: 1.3
                                        },
                                        {
                                            title: translate.instant('XIU_GIAI_8_AND_DB'),
                                            codePlay: "XIU8VDB",
                                            methodid: 211,
                                            rate: 3.7
                                        },
                                        {
                                            title: translate.instant('XIU_AND_CHAN_GIAI_8'),
                                            codePlay: "XIUCHAN8",
                                            methodid: 212,
                                            rate: 3.63
                                        },
                                        {
                                            title: translate.instant('XIU_AND_LE_GIAI_8'),
                                            codePlay: "XIULE8",
                                            methodid: 213,
                                            rate: 3.63
                                        },
                                        {
                                            title: translate.instant('XIU_AND_CHAN_GIAI_DB'),
                                            codePlay: "XIUCHANDB",
                                            methodid: 214,
                                            rate: 3.63
                                        },
                                        {
                                            title: translate.instant('XIU_AND_LE_GIAI_DB'),
                                            codePlay: "XIULEDB",
                                            methodid: 215,
                                            rate: 3.63
                                        }
                                    ]
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('METHOD_DESC_TAI_XIU'),
                        methodhelp: translate.instant('METHOD_HELP_TAI_XIU'),
                        guideTxt: translate.instant('GUIDE_TEXT_COMMON'),
                        methodexample: translate.instant('METHOD_EXAMPLE_COMMON'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    },
                    {
                        name: translate.instant('MMC.EVEN_ODD'),
                        methodid: 216,
                        selectType: "deTopBot",
                        selectArea: {
                            mname: "de-cl",
                            LayoutTopBot: [
                                {
                                    title: translate.instant('MMC.EVEN'),
                                    no: [
                                        {
                                            title: translate.instant('MMC.EVEN_PRIZE_8'),
                                            codePlay: "CHAN8",
                                            methodid: 216,
                                            rate: 1.95
                                        },
                                        {
                                            title: translate.instant('MMC.EVEN_PRIZE_DB'),
                                            codePlay: "CHANDB",
                                            methodid: 218,
                                            rate: 1.95
                                        },
                                        {
                                            title: translate.instant('MMC.EVEN_PRIZE_8_OR_DB'),
                                            codePlay: "CHAN8ORDB",
                                            methodid: 220,
                                            rate: 1.3
                                        },
                                        {
                                            title: translate.instant('MMC.EVEN_PRIZE_8_AND_DB'),
                                            codePlay: "CHAN8VDB",
                                            methodid: 223,
                                            rate: 3.7
                                        },
                                    ]
                                },
                                {
                                    title: translate.instant('MMC.ODD'),
                                    no: [{
                                        title: translate.instant('MMC.ODD_PRIZE_8'),
                                        codePlay: "LE8",
                                        methodid: 217,
                                        rate: 1.95
                                    },
                                    {
                                        title: translate.instant('MMC.ODD_PRIZE_DB'),
                                        codePlay: "LEDB",
                                        methodid: 219,
                                        rate: 1.95
                                    },
                                    {
                                        title: translate.instant('MMC.ODD_PRIZE_8_OR_DB'),
                                        codePlay: "LE8ORDB",
                                        methodid: 221,
                                        rate: 1.3
                                    },
                                    {
                                        title: translate.instant('MMC.ODD_PRIZE_8_AND_DB'),
                                        codePlay: "LE8DB",
                                        methodid: 222,
                                        rate: 3.7
                                    },
                                    ]
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.EVEN_ODD_DESC'),
                        methodhelp: `
                            <b>${translate.instant('MMC.EVEN_ODD_HELP.EVEN_PRIZE_8')}</b><br>
                            <b>${translate.instant('MMC.EVEN_ODD_HELP.ODD_PRIZE_8')}</b><br>
                            <b>${translate.instant('MMC.EVEN_ODD_HELP.EVEN_PRIZE_DB')}</b><br>
                            <b>${translate.instant('MMC.EVEN_ODD_HELP.ODD_PRIZE_DB')}</b><br>
                            <b>${translate.instant('MMC.EVEN_ODD_HELP.EVEN_PRIZE_8_OR_DB')}</b><br>
                            <b>${translate.instant('MMC.EVEN_ODD_HELP.ODD_PRIZE_8_OR_DB')}</b><br>
                            <b>${translate.instant('MMC.EVEN_ODD_HELP.ODD_PRIZE_8_AND_DB')}</b><br>
                            <b>${translate.instant('MMC.EVEN_ODD_HELP.EVEN_PRIZE_8_AND_DB')}</b><br>`,
                        guideTxt: translate.instant('MMC.GUIDE_TXT'),
                        methodexample: translate.instant('MMC.EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    },

                    {
                        name: translate.instant('MMC.DRAGON_TIGER.TITLE'),
                        methodid: 224,
                        selectType: "deTopBot",
                        selectArea: {
                            mname: "de-hr",
                            LayoutTopBot: [
                                {
                                    title: translate.instant('MMC.DRAGON_TIGER.TITLE'),
                                    no: [
                                        {
                                            title: translate.instant('MMC.DRAGON_TIGER.DRAGON'),
                                            codePlay: "RONG",
                                            methodid: 224,
                                            rate: 1.95
                                        },
                                        {
                                            title: translate.instant('MMC.DRAGON_TIGER.TIGER'),
                                            codePlay: "Ho",
                                            methodid: 225,
                                            rate: 1.95
                                        },
                                        {
                                            title: translate.instant('MMC.DRAGON_TIGER.DRAW'),
                                            codePlay: "RHHOA",
                                            methodid: 226,
                                            rate: 90
                                        }
                                    ]
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.DRAGON_TIGER.METHOD_DESC'),
                        methodhelp: translate.instant('MMC.DRAGON_TIGER.METHOD_HELP'),
                        guideTxt: translate.instant('GUIDE_TEXT_COMMON'),
                        methodexample: translate.instant('METHOD_EXAMPLE_COMMON'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: translate.instant('VND'),
                            rate: 1
                        }]
                    },

                    {
                        name: translate.instant('SO_DOI'),
                        methodid: 227,
                        selectType: "deTopBot",
                        selectArea: {
                            mname: "de-hr",
                            LayoutTopBot: [
                                {
                                    title: translate.instant('SO_DOI'),
                                    no: [
                                        {
                                            title: translate.instant('SO_DOI_GIAI_8'),
                                            codePlay: "SD8",
                                            methodid: 227,
                                            rate: 8.5
                                        },
                                        {
                                            title: translate.instant('SO_DOI_GIAI_8_OR_DB'),
                                            codePlay: "SD8DB",
                                            methodid: 228,
                                            rate: 5
                                        },
                                        {
                                            title: translate.instant('SO_DOI_GIAI_DB'),
                                            codePlay: "SDDB",
                                            methodid: 229,
                                            rate: 8.5
                                        },
                                        {
                                            title: translate.instant('SO_DOI_18_GIAI'),
                                            codePlay: "SD18",
                                            methodid: 230,
                                            rate: 1.12
                                        }
                                    ]
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('METHOD_DESC_SO_DOI'),
                        methodhelp: translate.instant('METHOD_HELP_SO_DOI'),
                        guideTxt: translate.instant('GUIDE_TEXT_COMMON'),
                        methodexample: translate.instant('METHOD_EXAMPLE_COMMON'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    },
                    {
                        name: translate.instant('TAM_CO_TU_QUY'),
                        methodid: 231,
                        selectType: "deTopBot",
                        selectArea: {
                            mname: "de-tctq",
                            LayoutTopBot: [
                                {
                                    title: translate.instant('TAM_CO_TU_QUY'),
                                    no: [
                                        {
                                            title: translate.instant('TAM_CO'),
                                            codePlay: "TAMCO",
                                            methodid: 231,
                                            rate: 5.5
                                        },
                                        {
                                            title: translate.instant('TU_QUY'),
                                            codePlay: "TUQUY",
                                            methodid: 232,
                                            rate: 60
                                        }
                                    ]
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('METHOD_DESC_TAM_CO_TU_QUY'),
                        methodhelp: translate.instant('METHOD_HELP_TAM_CO_TU_QUY'),
                        guideTxt: translate.instant('GUIDE_TEXT_COMMON'),
                        methodexample: translate.instant('METHOD_EXAMPLE_COMMON'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    },
                    {
                        name: translate.instant('MMC.EAST_WEST_NORTH_SOUTH'),
                        methodid: 233,
                        selectType: "deTopBot",
                        selectArea: {
                            mname: "de-tctq",
                            LayoutTopBot: [
                                {
                                    title: translate.instant('MMC.EAST'),
                                    no: [{
                                        title: translate.instant('MMC.EAST_PRIZE_8'),
                                        codePlay: "DONG8",
                                        methodid: 233,
                                        rate: 3.63
                                    },
                                    {
                                        title: translate.instant('MMC.EAST_PRIZE_DB'),
                                        codePlay: "DONGDB",
                                        methodid: 237,
                                        rate: 3.63
                                    },
                                    ]
                                },
                                {
                                    title: translate.instant('MMC.WEST'),
                                    no: [{
                                        title: translate.instant('MMC.WEST_PRIZE_8'),
                                        codePlay: "TAY8",
                                        methodid: 234,
                                        rate: 3.63
                                    },
                                    {
                                        title: translate.instant('MMC.WEST_PRIZE_DB'),
                                        codePlay: "TAYDB",
                                        methodid: 238,
                                        rate: 3.63
                                    },
                                    ]
                                },
                                {
                                    title: translate.instant('MMC.NORTH'),
                                    no: [{
                                        title: translate.instant('MMC.NORTH_PRIZE_8'),
                                        codePlay: "NAM8",
                                        methodid: 235,
                                        rate: 3.63
                                    },
                                    {
                                        title: translate.instant('MMC.NORTH_PRIZE_DB'),
                                        codePlay: "NAMDB",
                                        methodid: 239,
                                        rate: 3.63
                                    },
                                    ]
                                },
                                {
                                    title: translate.instant('MMC.SOUTH'),
                                    no: [{
                                        title: translate.instant('MMC.SOUTH_PRIZE_8'),
                                        codePlay: "BAC8",
                                        methodid: 236,
                                        rate: 3.63
                                    },
                                    {
                                        title: translate.instant('MMC.SOUTH_PRIZE_DB'),
                                        codePlay: "BACDB",
                                        methodid: 240,
                                        rate: 3.63
                                    },
                                    ]
                                }

                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.EAST_WEST_NORTH_SOUTH_DESC'),
                        methodhelp: `
                        <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.EAST_PRIZE_8')}</b><br>
                        <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.EAST_PRIZE_DB')}</b><br>
                        <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.WEST_PRIZE_8')}</b><br>
                        <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.WEST_PRIZE_DB')}</b><br>
                        <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.NORTH_PRIZE_8')}</b><br>
                        <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.NORTH_PRIZE_DB')}</b><br>
                        <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.SOUTH_PRIZE_8')}</b><br>
                        <b>${translate.instant('MMC.EAST_WEST_NORTH_SOUTH_HELP.SOUTH_PRIZE_DB')}</b><br>`,
                        guideTxt: translate.instant('MMC.GUIDE_TXT'),
                        methodexample: translate.instant('MMC.EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    },

                    {
                        name: translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH'),
                        methodid: 241,
                        selectType: "deTopBot",
                        selectArea: {
                            mname: "de-kmtht",
                            LayoutTopBot: [
                                {
                                    title: translate.instant('MMC.METAL'),
                                    no: [{
                                        title: translate.instant('MMC.METAL_PRIZE_8'),
                                        codePlay: "KIM8",
                                        methodid: 241,
                                        rate: 4.6
                                    },
                                    {
                                        title: translate.instant('MMC.METAL_PRIZE_DB'),
                                        codePlay: "KIMDB",
                                        methodid: 246,
                                        rate: 4.6
                                    },
                                    ]
                                },
                                {
                                    title: translate.instant('MMC.WOOD'),
                                    no: [{
                                        title: translate.instant('MMC.WOOD_PRIZE_8'),
                                        codePlay: "MOC8",
                                        methodid: 242,
                                        rate: 4.6
                                    },
                                    {
                                        title: translate.instant('MMC.WOOD_PRIZE_DB'),
                                        codePlay: "MOCDB",
                                        methodid: 247,
                                        rate: 4.6
                                    },
                                    ]
                                },
                                {
                                    title: translate.instant('MMC.WATER'),
                                    no: [{
                                        title: translate.instant('MMC.WATER_PRIZE_8'),
                                        codePlay: "THUY8",
                                        methodid: 201,
                                        rate: 4.6
                                    },
                                    {
                                        title: translate.instant('MMC.WATER_DB'),
                                        codePlay: "THUYDB",
                                        methodid: 248,
                                        rate: 4.6
                                    },
                                    ]
                                },
                                {
                                    title: translate.instant('MMC.FIRE'),
                                    no: [{
                                        title: translate.instant('MMC.FIRE_PRIZE_8'),
                                        codePlay: "HOA8",
                                        methodid: 201,
                                        rate: 4.6
                                    },
                                    {
                                        title: translate.instant('MMC.FIRE_DB'),
                                        codePlay: "HOADB",
                                        methodid: 249,
                                        rate: 4.6
                                    },
                                    ]
                                },
                                {
                                    title: translate.instant('MMC.EARTH'),
                                    no: [{
                                        title: translate.instant('MMC.EARTH_PRIZE_8'),
                                        codePlay: "THO8",
                                        methodid: 201,
                                        rate: 4.6
                                    },
                                    {
                                        title: translate.instant('MMC.EARTH_DB'),
                                        codePlay: "THODB",
                                        methodid: 250,
                                        rate: 4.6
                                    },
                                    ]
                                }

                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_DESC'),
                        methodhelp: `
                        <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.METAL_PRIZE_8')}</b><br>
                        <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.METAL_PRIZE_DB')}</b><br>
                        <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.WOOD_PRIZE_8')}</b><br>
                        <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.WOOD_PRIZE_DB')}</b><br>
                        <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.WATER_PRIZE_8')}</b><br>
                        <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.WATER_DB')}</b><br>
                        <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.FIRE_PRIZE_8')}</b><br>
                        <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.FIRE_DB')}</b><br>
                        <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.EARTH_PRIZE_8')}</b><br>
                        <b>${translate.instant('MMC.METAL_WOOD_WATER_FIRE_EARTH_HELP.EARTH_DB')}</b><br>`,
                        guideTxt: translate.instant('MMC.GUIDE_TXT'),
                        methodexample: translate.instant('MMC.EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    },

                ]
            }
        ]
    },

    {
        isdefault: false,
        title: translate.instant('MMC.BAO_LO'),
        status: 0,
        label: [
            {
                gtitle: translate.instant('MMC.SUPER_FAST'),
                label: [
                    {
                        name: translate.instant('MMC.LO_2_NUMBERS'),
                        methodid: 1,
                        selectType: "zxfs",
                        selectArea: {
                            mname: "lo2so",
                            layout: [
                                {
                                    title: translate.instant('MMC.DOZENS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('MMC.UNIT'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.LO_2_NUMBERS_DESC'),
                        methodhelp: translate.instant('MMC.LO_2_NUMBERS_HELP'),
                        guideTxt: translate.instant('MMC.GUIDE_TXT'),
                        methodexample: translate.instant('MMC.LO_2_NUMBERS_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    },
                    {
                        name: translate.instant('MMC.LO_3_NUMBERS'),
                        methodid: 2,
                        selectType: "zxfs",
                        selectArea: {
                            mname: "lo3so",
                            layout: [
                                {
                                    title: translate.instant('MMC.HUNDREDS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('MMC.DOZENS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('MMC.UNIT'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '000',
                                    end: '099'
                                },
                                {
                                    start: '100',
                                    end: '199'
                                },
                                {
                                    start: '200',
                                    end: '299'
                                },
                                {
                                    start: '300',
                                    end: '399'
                                },
                                {
                                    start: '400',
                                    end: '499'
                                },
                                {
                                    start: '500',
                                    end: '599'
                                },
                                {
                                    start: '600',
                                    end: '699'
                                },
                                {
                                    start: '700',
                                    end: '799'
                                },
                                {
                                    start: '800',
                                    end: '899'
                                },
                                {
                                    start: '900',
                                    end: '999'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.LO_3_NUMBERS_DESC'),
                        methodhelp: translate.instant('MMC.LO_3_NUMBERS_HELP'),
                        guideTxt: translate.instant('MMC.GUIDE_TXT'),
                        methodexample: translate.instant('MMC.LO_3_NUMBERS_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    },
                    {
                        name: translate.instant('MMC.LO_4_NUMBERS'),
                        methodid: 25,
                        selectType: "zxfs",
                        selectArea: {
                            mname: "lo4so",
                            layout: [
                                {
                                    title: translate.instant('MMC.THOUSANDS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('MMC.HUNDREDS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('MMC.DOZENS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('MMC.UNIT'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: []
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.LO_4_NUMBERS_DESC'),
                        methodhelp: translate.instant('MMC.LO_4_NUMBERS_HELP'),
                        guideTxt: translate.instant('MMC.GUIDE_TXT'),
                        methodexample: translate.instant('MMC.LO_4_NUMBERS_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    }
                ]
            }
        ]
    },
    {
        isdefault: false,
        title: translate.instant('MMC.LO_XIEN'),
        status: 0,
        label: [
            {
                gtitle: translate.instant('MMC.SUPER_FAST'),
                label: [
                    {
                        name: translate.instant('MMC.XIEN_2'),
                        methodid: 3,
                        selectType: "ds",
                        selectArea: {
                            mname: "lx2",
                            layout: [],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.XIEN_2_DESC'),
                        methodhelp: translate.instant('MMC.XIEN_2_HELP'),
                        guideTxt: translate.instant('MMC.XIEN_2_GUIDE'),
                        methodexample: translate.instant('MMC.XIEN_2_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    },
                    {
                        name: translate.instant('MMC.XIEN_3'),
                        methodid: 4,
                        selectType: "ds",
                        selectArea: {
                            mname: "lx3",
                            layout: [],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.XIEN_3_DESC'),
                        methodhelp: translate.instant('MMC.XIEN_3_HELP'),
                        guideTxt: translate.instant('MMC.XIEN_3_GUIDE'),
                        methodexample: translate.instant('MMC.XIEN_3_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    },
                    {
                        name: translate.instant('MMC.XIEN_4'),
                        methodid: 5,
                        selectType: "ds",
                        selectArea: {
                            mname: "lx4",
                            layout: [],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.XIEN_4_DESC'),
                        methodhelp: translate.instant('MMC.XIEN_4_HELP'),
                        guideTxt: translate.instant('MMC.XIEN_4_GUIDE'),
                        methodexample: translate.instant('MMC.XIEN_4_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    }
                ]
            }
        ]
    },

    {
        isdefault: false,
        title: translate.instant('MMC.HEAD_TAIL'),
        status: 0,
        label: [
            {
                gtitle: translate.instant('MMC.SUPER_FAST'),
                label: [
                    {
                        name: translate.instant('MMC.HEAD'),
                        methodid: 9,
                        selectType: "zxfs",
                        selectArea: {
                            mname: "dau",
                            layout: [
                                {
                                    title: translate.instant('MMC.DOZENS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: []
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.HEAD_DESC'),
                        methodhelp: translate.instant('MMC.HEAD_HELP'),
                        methodexample: translate.instant('MMC.HEAD_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    },
                    {
                        name: translate.instant('MMC.TAIL'),
                        methodid: 10,
                        selectType: "zxfs",
                        selectArea: {
                            mname: "duoi",
                            layout: [
                                {
                                    title: translate.instant('MMC.UNIT'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: []
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.TAIL_DESC'),
                        methodhelp: translate.instant('MMC.TAIL_HELP'),
                        methodexample: translate.instant('MMC.TAIL_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    }
                ]
            }
        ]
    },
    {
       
        isdefault: false,
        title: translate.instant('MMC.THREE_CANG'),
        status: 0,
        label: [
            {
                gtitle: translate.instant('MMC.SUPER_FAST'),
                label: [
                    {
                        name: translate.instant('MMC.THREE_CANG_HEAD'),
                        methodid: 11,
                        selectType: "zxfs",
                        selectArea: {
                            mname: "3cangdau",
                            layout: [
                                {
                                    title: translate.instant('MMC.HUNDREDS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('MMC.DOZENS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('MMC.UNIT'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '000',
                                    end: '099'
                                },
                                {
                                    start: '100',
                                    end: '199'
                                },
                                {
                                    start: '200',
                                    end: '299'
                                },
                                {
                                    start: '300',
                                    end: '399'
                                },
                                {
                                    start: '400',
                                    end: '499'
                                },
                                {
                                    start: '500',
                                    end: '599'
                                },
                                {
                                    start: '600',
                                    end: '699'
                                },
                                {
                                    start: '700',
                                    end: '799'
                                },
                                {
                                    start: '800',
                                    end: '899'
                                },
                                {
                                    start: '900',
                                    end: '999'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.THREE_CANG_HEAD_DESC'),
                        methodhelp: translate.instant('MMC.THREE_CANG_HEAD_HELP'),
                        guideTxt: translate.instant('MMC.GUIDE_TXT'),
                        methodexample: translate.instant('MMC.THREE_CANG_HEAD_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    },
                    {
                        name: translate.instant('MMC.THREE_CANG_SPECIAL.TITLE'),
                        methodid: 12,
                        selectType: "zxfs",
                        selectArea: {
                            mname: "3cangdacbiet",
                            layout: [
                                {
                                    title: translate.instant('MMC.HUNDREDS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('MMC.DOZENS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('MMC.UNIT'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '000',
                                    end: '099'
                                },
                                {
                                    start: '100',
                                    end: '199'
                                },
                                {
                                    start: '200',
                                    end: '299'
                                },
                                {
                                    start: '300',
                                    end: '399'
                                },
                                {
                                    start: '400',
                                    end: '499'
                                },
                                {
                                    start: '500',
                                    end: '599'
                                },
                                {
                                    start: '600',
                                    end: '699'
                                },
                                {
                                    start: '700',
                                    end: '799'
                                },
                                {
                                    start: '800',
                                    end: '899'
                                },
                                {
                                    start: '900',
                                    end: '999'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.THREE_CANG_SPECIAL_DESC'),
                        methodhelp: translate.instant('MMC.THREE_CANG_SPECIAL_HELP'),
                        guideTxt: translate.instant('MMC.GUIDE_TXT'),
                        methodexample: translate.instant('MMC.THREE_CANG_SPECIAL_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    },
                    {
                        name: translate.instant('MMC.THREE_CANG_HEAD_TAIL'),
                        methodid: 13,
                        selectType: "zxfs",
                        selectArea: {
                            mname: "3cangdauduoi",
                            layout: [
                                {
                                    title: translate.instant('MMC.HUNDREDS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('MMC.DOZENS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('MMC.UNIT'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '000',
                                    end: '099'
                                },
                                {
                                    start: '100',
                                    end: '199'
                                },
                                {
                                    start: '200',
                                    end: '299'
                                },
                                {
                                    start: '300',
                                    end: '399'
                                },
                                {
                                    start: '400',
                                    end: '499'
                                },
                                {
                                    start: '500',
                                    end: '599'
                                },
                                {
                                    start: '600',
                                    end: '699'
                                },
                                {
                                    start: '700',
                                    end: '799'
                                },
                                {
                                    start: '800',
                                    end: '899'
                                },
                                {
                                    start: '900',
                                    end: '999'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.THREE_CANG_HEAD_TAIL_DESC'),
                        methodhelp: translate.instant('MMC.THREE_CANG_HEAD_TAIL_HELP'),
                        guideTxt: translate.instant('MMC.GUIDE_TXT'),
                        methodexample: translate.instant('MMC.THREE_CANG_HEAD_TAIL_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    }
                ]
            }
        ]
    },
    {
        isdefault: false,
        title: translate.instant('MMC.FOUR_CANG'),
        status: 0,
        label: [
            {
                gtitle: translate.instant('MMC.SUPER_FAST'),
                label: [
                    {
                        name: translate.instant('MMC.FOUR_CANG_SPECIAL'),
                        methodid: 24,
                        selectType: "zxfs",
                        selectArea: {
                            mname: "4cangdacbiet",
                            layout: [
                                {
                                    title: translate.instant('MMC.THOUSANDS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('MMC.HUNDREDS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('MMC.DOZENS'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                },
                                {
                                    title: translate.instant('MMC.UNIT'),
                                    no: "0|1|2|3|4|5|6|7|8|9"
                                }
                            ],
                            noBigIndex: 5,
                            layoutfastslect: []
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.FOUR_CANG_SPECIAL_DESC'),
                        methodhelp: translate.instant('MMC.FOUR_CANG_SPECIAL_HELP'),
                        guideTxt: translate.instant('MMC.GUIDE_TXT'),
                        methodexample: translate.instant('MMC.FOUR_CANG_SPECIAL_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    }
                ]
            }
        ]
    },
    {
        isdefault: false,
        title: translate.instant('MMC.LO_TRUOT'),
        status: 0,
        label: [
            {
                gtitle: translate.instant('MMC.SUPER_FAST'),
                label: [
                    {
                        name: translate.instant('MMC.TRUOT_XIEN_4'),
                        methodid: 27,
                        selectType: "ds",
                        selectArea: {
                            mname: "lt4",
                            layout: [],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.TRUOT_XIEN_4_DESC'),
                        methodhelp: translate.instant('MMC.TRUOT_XIEN_4_HELP'),
                        guideTxt: translate.instant('MMC.TRUOT_XIEN_4_GUIDE'),
                        methodexample: translate.instant('MMC.TRUOT_XIEN_4_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    },
                    {
                        name: translate.instant('MMC.TRUOT_XIEN_8'),
                        methodid: 29,
                        selectType: "ds",
                        selectArea: {
                            mname: "lt8",
                            layout: [],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.TRUOT_XIEN_8_DESC'),
                        methodhelp: translate.instant('MMC.TRUOT_XIEN_8_HELP'),
                        guideTxt: translate.instant('MMC.TRUOT_XIEN_8_GUIDE'),
                        methodexample: translate.instant('MMC.TRUOT_XIEN_8_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    },
                    {
                        name: translate.instant('MMC.TRUOT_XIEN_10'),
                        methodid: 31,
                        selectType: "ds",
                        selectArea: {
                            mname: "lt10",
                            layout: [],
                            noBigIndex: 5,
                            layoutfastslect: [
                                {
                                    start: '00',
                                    end: '99'
                                }
                            ]
                        },
                        show_str: "X,X,X,X,X",
                        methoddesc: translate.instant('MMC.TRUOT_XIEN_10_DESC'),
                        methodhelp: translate.instant('MMC.TRUOT_XIEN_10_HELP'),
                        guideTxt: translate.instant('MMC.TRUOT_XIEN_10_GUIDE'),
                        methodexample: translate.instant('MMC.TRUOT_XIEN_10_EXAMPLE'),
                        exampleInfo: "",
                        modes: [{
                            modeid: 1,
                            name: "VND",
                            rate: 1
                        }]
                    }
                ]
            }
        ]
    },
];




// WEBPACK FOOTER //
// ./src/+lotteryFace/mmc.ts